import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Ecommerce">
                <h1>Ecommerce Software Development Services</h1>
              </div>
              <p className="main_para">
                E-commerce solutions for the online stores. Talk to our business
                analysts and find a solution to meet your business goals.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                Experience digital commerce transformation with scalable
                ecommerce development services creating and selling platforms,
                including websites, mobile and web apps, and an ecommerce
                Software as a Service program.
              </p>
              <ul>
                <li>Sales &amp; Analytics Integration</li>
                <li>Adaptable &amp; Scalable Solutions</li>
                <li>Intuitive, Consumer-Centric Storefronts</li>
                <li>Low-Cost Customer Acquisition</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
